import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { RegisterScreen } from '../components/auth/RegisterScreen';
import { DappMainScreen } from '../components/dapp/DappMainScreen';
import { DappProfileScreen } from '../components/dapp/DappProfileScreen';
import { DappContract } from '../components/dapp/DappContract';
import { DappMyContrats } from '../components/dapp/DappMyContrats';
import { DappContacts } from '../components/dapp/DappContacts';
import { DappMyProfile } from '../components/dapp/DappMyProfile';
import { DappDetailsContract } from '../components/dapp/DappDetailsContract';

export const DappRouter = () => {
    return (
        <div className="auth__main">
            <div className="auth__box-container">
                <Switch>
                    <Route
                        exact
                        path="/dapp/home"
                        component={DappMainScreen}
                    />

                    <Route
                        exact
                        path="/dapp/profile"
                        component={DappProfileScreen}
                    />

                    <Route
                        exact
                        path="/dapp/contract"
                        component={DappContract}
                    />


                    <Route
                        exact
                        path="/dapp/mycontracts"
                        component={DappMyContrats}
                    />



                    <Route
                        exact
                        path="/dapp/mycontacts"
                        component={DappContacts}
                    />

                    <Route
                        exact
                        path="/dapp/myprofile"
                        component={DappMyProfile}
                    />


                    <Route
                        path="/dapp/contract/:id"
                        component={DappDetailsContract}
                    />

                    <Redirect to="/dapp/home" />


                </Switch>
            </div>

        </div>
    )
}
